<div class="warehouse-dropdown">
  <ul class="m-0 p-0 w-100">
    @for (item of package; track item; let i = $index) {
      <li
        (click)="item.showButton ? null : onItemSelected(item.label); onClick.emit(item)"
        class="d-flex align-items-center spacing-8 justify-content-between package-list cursor-pointer"
        tabindex="0">
        <div class="h4-bold primary-100 d-flex flex-column align-items-start spacing-4">
          <div class="d-flex align-items-center spacing-8">
            <app-ce-icon [name]="item.icon" [svg_class]="['primary-50']"></app-ce-icon>
            {{ item.label }}
          </div>
          <span class="h4-reg primary-60" [class.d-none]="item.tagLine === ''">{{
            item.tagLine
          }}</span>
        </div>
        @if (item.showButton) {
          <app-secondary-btns
            (onClick)="onSetupNowClick()"
            [active]="false"
            [disabled]="false"
            label="Setup now"
            size="large"
            Type="withoutIcon"
            IconValue=""
            IconType="external">
          </app-secondary-btns>
        }
      </li>
    }
  </ul>
</div>
